import React, { useState } from 'react';
import './SupportFAQ.css';

const SupportFAQ = () => {
  const [activeQuestion, setActiveQuestion] = useState(null);

  const faqItems = [
    {
      id: 1,
      question: "How do I track my anime/manga watching progress?",
      answer: "To track your anime or manga progress, add titles to your collection by clicking the 'Add to Collection' button on any anime or manga page. Then, you can update your progress from your profile page or directly from the title page by using the status dropdown and episode/chapter counter."
    },
    {
      id: 2,
      question: "How do I report incorrect information about an anime or manga?",
      answer: "If you find incorrect information, you can submit a report by using the 'Submit a Report' section in the Support Center. Select 'Incorrect Information' as the report type, provide a clear title and description, and include the correct information. Our team will review your report and make necessary updates."
    },
    {
      id: 3,
      question: "Why can't I find a specific anime or manga?",
      answer: "Our database is continuously growing, but there might be titles that haven't been added yet. If you can't find a specific anime or manga, you can submit a 'Missing Content' report from the Support Center, and our team will work on adding it to the database."
    },
    {
      id: 4,
      question: "How long does it take for a report to be resolved?",
      answer: "Report resolution times vary depending on the type and complexity of the issue. Simple corrections are typically processed within 1-3 days, while more complex issues or feature requests may take longer. You can track the status of your reports in the 'My Reports' section."
    },
    {
      id: 5,
      question: "Can I suggest new features for the website?",
      answer: "Absolutely! We welcome feature suggestions. Use the 'Submit a Report' section in the Support Center and select 'Feature Request' as the report type. Please provide a clear description of the feature you'd like to see and how it would improve your experience."
    },
    {
      id: 6,
      question: "How do I update my account information?",
      answer: "You can update your account information, including your username, email, profile picture, and preferences by going to your profile and clicking on the 'Settings' option. From there, navigate to the 'Account' tab to make your changes."
    },
    {
      id: 7,
      question: "What should I do if I encounter a bug or technical issue?",
      answer: "If you encounter a bug or technical issue, please report it through the 'Submit a Report' section in the Support Center. Select 'Bug/Technical Issue' as the report type, describe the problem in detail, and include steps to reproduce the issue if possible. Screenshots or recordings are also helpful."
    },
    {
      id: 8,
      question: "How do I recover my password if I forget it?",
      answer: "If you forget your password, go to the login page and click on the 'Forgot Password' link. Enter your email address, and you'll receive a password reset link. Follow the instructions in the email to create a new password."
    },
    {
      id: 9,
      question: "Can I connect my account with other anime/manga services?",
      answer: "We're working on implementing integration with other services. Currently, you can import your anime/manga list from MyAnimeList. More integrations will be available in the future."
    },
    {
      id: 10,
      question: "How can I contact the support team directly?",
      answer: "The best way to contact our support team is through the report system in the Support Center. For urgent matters, you can email us at support@animewebsite.com. Please note that response times may vary depending on the volume of inquiries."
    }
  ];

  const toggleQuestion = (id) => {
    if (activeQuestion === id) {
      setActiveQuestion(null);
    } else {
      setActiveQuestion(id);
    }
  };

  return (
    <div className="faq-container">
      <h2>Frequently Asked Questions</h2>
      <p className="faq-description">
        Find answers to common questions about our platform. If you don't see your question here, feel free to submit a report.
      </p>

      <div className="search-faq">
        <i className="fa-solid fa-magnifying-glass"></i>
        <input 
          type="text" 
          placeholder="Search questions..."
          onChange={(e) => {
            // Future implementation: Filter FAQ items based on search query
            console.log("Search query:", e.target.value);
          }} 
        />
      </div>

      <div className="faq-list">
        {faqItems.map(item => (
          <div key={item.id} className={`faq-item ${activeQuestion === item.id ? 'active' : ''}`}>
            <div className="faq-question" onClick={() => toggleQuestion(item.id)}>
              <h3>{item.question}</h3>
              <button className="toggle-btn">
                <i className={`fa-solid ${activeQuestion === item.id ? 'fa-minus' : 'fa-plus'}`}></i>
              </button>
            </div>
            <div className="faq-answer">
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="contact-info">
        <h3>Still need help?</h3>
        <p>If you couldn't find an answer to your question, please submit a report or contact our support team directly at <a href="mailto:support@animewebsite.com">support@animewebsite.com</a>.</p>
      </div>
    </div>
  );
};

export default SupportFAQ;